<div class="recorder-container">
  <button mat-icon-button (click)="recording ? stopRecording() : startRecording()" [class.is-recording]="recording">
    <svg class="svg" aria-hidden="true">
      <use ogSvgUnify="assets/sprite/sprite.svg#video"></use>
    </svg>
  </button>
</div>

<div class="video-container" [style.display]="recording ? 'block' : 'none'">
  <video #previewVideo playsinline></video>
</div>
